import { LoadingButton } from '@mui/lab';
import {
    Button,
    Card,
    CardContent,
    Modal,
    Stack,
    Typography,
} from '@mui/material';
import React from 'react';

export default function ConfirmSheet({
    open,
    title,
    onConfirm,
    onCancel,
    isLoading,
}) {
    return (
        <Modal open={open}>
            <Card sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
                <CardContent>
                    <Typography>{title || 'Are you sure?'}</Typography>
                    <Stack spacing={1} direction="row" sx={{ mt: 1 }}>
                        <Button onClick={onCancel} variant="outlined">
                            Cancel
                        </Button>
                        <LoadingButton
                            variant="contained"
                            onClick={onConfirm}
                            loading={isLoading}
                        >
                            Confirm
                        </LoadingButton>
                    </Stack>
                </CardContent>
            </Card>
        </Modal>
    );
}
